"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservatorCell = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../../../Icon");
require("./ReservatorCell.scss");
const className = 'reservation-list-reservator';
const ReservatorCell = (props) => {
    const { value } = props;
    if (!value)
        return null;
    const name = value.displayName;
    const map = {
        customer: 'customer',
        agent: 'agent',
        manager: 'malesia',
    };
    const icon = value.type ? map[value.type] : undefined;
    return (react_1.default.createElement("div", { className: className },
        icon && (react_1.default.createElement("div", { className: `${className}__icon` },
            react_1.default.createElement(Icon_1.Icon, { name: icon }))),
        name && (react_1.default.createElement("div", { className: `${className}__name` }, name))));
};
exports.ReservatorCell = ReservatorCell;
//# sourceMappingURL=ReservatorCell.js.map